import { InfoCircleOutlined } from '@ant-design/icons';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${COLOR_OPTIONS.NEUTRAL_80};
  font-family: 'Noto Sans';
`;

export const NotesWrapper = styled.div`
  margin-top: 8px;
`;

export const Notes = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

export const HowToInterpretWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 24px 0;
`;

export const HowToInterpret = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoIcon = styled(InfoCircleOutlined)`
  font-size: 20px;
  color: ${COLOR_OPTIONS.GREEN_60};
`;

export const Topics = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;
`;

export const TopicItem = styled.li`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PestManagementWrapper = styled.div`
  font-weight: 600;
  font-style: italic;
`;

export const RiskLevelWrapper = styled.div`
  margin-top: 11px;
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`;

export const RiskLevel = styled.div<{ $backgroundColor: string; $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 21px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
`;
